import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn } from "./PhysShell.jsx";
import { newton, round } from "./physcore.js";

export default function Force() {
  const [F, setF] = useState("");
  const [m, setM] = useState("10");
  const [a, setA] = useState("9.81");
  const [res, setRes] = useState(null);

  const go = () => {
    const p = (x) => (x.trim() === "" ? null : parseFloat(x));
    setRes(newton({ F: p(F), m: p(m), a: p(a) }));
  };

  return (
    <PhysShell title="Newton's 2nd Law">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        F = ma. Fill two, leave the unknown blank.
      </p>
      <Field label="Force F" suffix="N" value={F} onChange={(e) => setF(e.target.value)} placeholder="—" />
      <Field label="Mass m" suffix="kg" value={m} onChange={(e) => setM(e.target.value)} placeholder="—" />
      <Field label="Acceleration a" suffix="m/s²" value={a} onChange={(e) => setA(e.target.value)} placeholder="—" />
      <button onClick={go} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="Force F" value={round(res.result.F, 4)} unit="N" />
          <Stat label="Mass m" value={round(res.result.m, 4)} unit="kg" />
          <Stat label="Acceleration a" value={round(res.result.a, 4)} unit="m/s²" />
          <div style={{ marginTop: 12, fontSize: 13, color: "#9A9DBE" }}>Used: {res.formula}</div>
        </ResultCard>
      )}
    </PhysShell>
  );
}

